import { render, staticRenderFns } from "./ProcessosJudiciaisTotalizadores.vue?vue&type=template&id=704ddc59&lang=pug"
import script from "./ProcessosJudiciaisTotalizadores.vue?vue&type=script&lang=js"
export * from "./ProcessosJudiciaisTotalizadores.vue?vue&type=script&lang=js"
import style0 from "./ProcessosJudiciaisTotalizadores.vue?vue&type=style&index=0&id=704ddc59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports